import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { guardarToken } from "./api";
import "./painel.css";

/**
 * Entrada da aplicação.
 *
 * O token da sessão é lido uma vez do fragmento da URL (`#token=...`), guardado
 * em memória e **removido da barra de endereços** com `replaceState`. Token em
 * query string vai parar no log do proxy e no histórico do navegador; no
 * fragmento, ao menos não é enviado ao servidor — e apagá-lo em seguida tira do
 * histórico o que sobraria.
 *
 * É a ponte enquanto o login do Keycloak não está ligado (sprint de identidade).
 * Quando estiver, este bloco sai e o token vem do fluxo OIDC.
 */
const fragmento = new URLSearchParams(window.location.hash.slice(1));
const token = fragmento.get("token");
if (token) {
  guardarToken(token);
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
}

createRoot(document.getElementById("raiz")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
